import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import debounce from 'lodash/debounce';
import { VIDEO_SIZES } from '~/const/images';
import { SLOW_TIMER } from '~/const/timers';
export default {
  props: {
    loop: {
      type: Boolean,
      default: true
    },
    muted: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
    webkitPlaysinline: {
      type: Boolean,
      default: true
    },
    playsinline: {
      type: Boolean,
      default: true
    },
    videos: {
      type: Object,
      default: () => {}
    },
    videoImages: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      widthWindow: null,
      selectedVideo: '',
      selectedImage: ''
    };
  },

  mounted() {
    this.initVideoUrl();
    window.addEventListener('resize', debounce(this.initVideoUrl, SLOW_TIMER));
  },

  destroyed() {
    window.removeEventListener('resize', this.initVideoUrl);
  },

  methods: {
    initVideoUrl() {
      this.widthWindow = window.innerWidth;
      var sizeValues = Object.values(VIDEO_SIZES);
      var indexSize = sizeValues.findIndex(size => this.widthWindow <= size);
      indexSize = indexSize !== -1 ? indexSize : sizeValues.length - 1;
      this.selectedVideo = this.videos[Object.keys(VIDEO_SIZES)[indexSize]];
      this.selectedImage = this.videoImages[Object.keys(VIDEO_SIZES)[indexSize]];
    }

  }
};